export const CD_CHECKOUT_URL = 'https://buy.stripe.com/00w14gbJC9Xd5Rb3Zr5Ne01';
export const BIKINI_RELEASE_ID = 'nsr-01-a1x-rogue';
export const HCW_RELEASE_ID = 'nsr-04-hcw';
export const CLEARANCE_STORAGE_KEY = 'nsr_clearance';
export const CLEARANCE_EVENT = 'nsr-clearance-changed';
